/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   tabs-automatic.js
 *
 *   Desc:   Tablist widget that implements ARIA Authoring Practices
 */

'use strict';

class TabsAutomatic {
    constructor(groupNode) {
        this.tablistNode = groupNode;
        this.tabs = [];

        this.firstTab = null;
        this.lastTab = null;
        this.activeIndex = 0;

        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabpanels = [];
        this.previousButton = this.tablistNode.querySelector('.previous');
        this.nextButton = this.tablistNode.querySelector('.next');

        for (var i = 0; i < this.tabs.length; i += 1) {
            var tab = this.tabs[i];
            var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

            tab.tabIndex = -1;
            tab.setAttribute('aria-selected', 'false');
            this.tabpanels.push(tabpanel);

            tab.addEventListener('keydown', this.onKeydown.bind(this));
            tab.addEventListener('click', this.onClick.bind(this));

            if (!this.firstTab) {
                this.firstTab = tab;
            }
            this.lastTab = tab;
        }

        this.setSelectedTab(this.firstTab, false);

        this.previousButton.addEventListener('click', this.onPreviousClick.bind(this))
        this.nextButton.addEventListener('click', this.onNextClick.bind(this))
    }

    setSelectedTab(currentTab, setFocus) {
        if (typeof setFocus !== 'boolean') {
            setFocus = true;
        }
        for (var i = 0; i < this.tabs.length; i += 1) {
            let tab = this.tabs[i];
            let panel = this.tabpanels[i];
            if (currentTab === tab) {
                tab.setAttribute('aria-selected', 'true');
                tab.removeAttribute('tabindex');
                panel.classList.remove('is-hidden');
                if (setFocus) {
                    tab.focus();
                }
                // slight delay here so CSS can animate opacity
                setTimeout(() => {
                    panel.classList.add('is-shown');
                }, 100);
            } else {
                tab.setAttribute('aria-selected', 'false');
                tab.tabIndex = -1;
                panel.classList.add('is-hidden');
                panel.classList.remove('is-shown');
            }
        }
    }

    setSelectedToPreviousTab(currentTab) {
        if (currentTab === this.firstTab) {
            this.activeIndex = this.tabs.length - 1;
            this.setSelectedTab(this.lastTab);
            this.nextButton.setAttribute('disabled', true);
        } else {
            this.activeIndex = this.activeIndex - 1;
            this.setSelectedTab(this.tabs[this.activeIndex]);
            this.nextButton.removeAttribute('disabled');
            if (this.activeIndex === 0) {
                this.previousButton.setAttribute('disabled', true);
            }
        }
    }

    setSelectedToNextTab(currentTab) {
        if (currentTab === this.lastTab) {
            this.activeIndex = 0;
            this.setSelectedTab(this.firstTab);
            this.previousButton.setAttribute('disabled', true);
        } else {
            this.activeIndex = this.activeIndex + 1;
            this.setSelectedTab(this.tabs[this.activeIndex]);
            this.previousButton.removeAttribute('disabled');
            if (this.activeIndex === this.tabs.length - 1) {
                this.nextButton.setAttribute('disabled', true);
            }
        }
    }

    /* EVENT HANDLERS */

    onKeydown(event) {
        var tgt = event.currentTarget,
            flag = false;

        switch (event.key) {
            case 'ArrowLeft':
                this.setSelectedToPreviousTab(tgt);
                flag = true;
                break;

            case 'ArrowRight':
                this.setSelectedToNextTab(tgt);
                flag = true;
                break;

            case 'Home':
                this.setSelectedTab(this.firstTab);
                flag = true;
                break;

            case 'End':
                this.setSelectedTab(this.lastTab);
                flag = true;
                break;

            default:
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onClick(event) {
        event.preventDefault();
        this.setSelectedTab(event.currentTarget);
    }

    onPreviousClick(event) {
        event.preventDefault();
        this.setSelectedToPreviousTab(this.tabs[this.activeIndex]);
    }

    onNextClick(event) {
        event.preventDefault();
        this.setSelectedToNextTab(this.tabs[this.activeIndex]);
    }
}

// Initialize tablist

window.addEventListener('load', function () {
    var tablists = document.querySelectorAll('.tab-controls');
    for (var i = 0; i < tablists.length; i++) {
        new TabsAutomatic(tablists[i]);
    }
});

import { debounce } from './utils';
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const tabs = document.querySelectorAll('.tab-controls');

function initTabGroupSwiper() {
    tabs.forEach(element => {
        const swiperContainer = element.querySelector('.swiper');
        // if we already have a swiper initialized, bail for desktop and destroy for mobile
        if (swiperContainer.swiper) {
            if (window.outerWidth > 1025) {
                return;
            }
            swiperContainer.swiper.destroy(false, true);
            return;
        }
        // only init for desktop
        if (window.outerWidth > 1025) {
            const swiper = new Swiper(swiperContainer, {
                modules: [Navigation, Pagination, A11y],
                a11y: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                speed: 600
            });
        }
    });
}
initTabGroupSwiper();
window.addEventListener('resize', debounce(initTabGroupSwiper, 300));
